var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("simpleList", {
    attrs: { ulClass: _vm.ulClass, liClass: _vm.liClass, data: _vm.data },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (slProps) {
          return [
            _c("a", { attrs: { href: _vm.getUrl(slProps.item.id) } }, [
              _vm._v(_vm._s(slProps.item.name)),
            ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }